import { gql } from '@apollo/client'
import { USER_FIELDS } from './fragments'

export const CURRENT = gql`
  query current {
    me {
      ...USER_FIELDS
    }
  }
  ${USER_FIELDS}
`

export const SIGN_IN = gql`
  mutation signinUser ($SigninUserInput: SigninUserInput!) {
    signinUser(input: $SigninUserInput) {
      token
      user {
        ...USER_FIELDS
      }
    }
  }
  ${USER_FIELDS}
`
